import React from 'react';
import { SelectProps } from 'antd';

import {
  StyledAntdSelect,
} from './style';

const CVSelect = (props: SelectProps<any>): JSX.Element => ( // eslint-disable-line
  <StyledAntdSelect {...props} />
);

CVSelect.Option = StyledAntdSelect.Option;

export default CVSelect;
